export default __webpack_public_path__ + "static/media/enterpriseActivity.e16cc714.svg";